<template>
  <div class="button-container">
    <button class="custom-btn primary" @click="goToOrderdb">下单库</button>
    <button class="custom-btn secondary" @click="goToTransorderdb">转单库</button>
    <button class="custom-btn outline" @click="goToPgorderdb">海量库</button>
  </div>
</template>

<script>
export default {
  name: 'OrderComparison',
  methods: {
    goToOrderdb() {
      this.$router.push('/ordercomparison/orderdb');
    },
    goToTransorderdb() {
      this.$router.push('/ordercomparison/transorderdb');
    },
    goToPgorderdb() {
      this.$router.push('/ordercomparison/pgdb');
    }
  }
};
</script>

<style scoped>
.button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 3rem;
  padding: 3rem;
  min-height: 100vh;
  background-color: #f5f6fa;
}

.custom-btn {
  padding: 20px 60px;
  font-size: 24px;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 600;
  border: none;
  min-width: 200px;
}

.custom-btn.primary {
  background: #3498db;
  color: white;
  box-shadow: 0 8px 15px rgba(52, 152, 219, 0.3);
}

.custom-btn.primary:hover {
  background: #2980b9;
  transform: translateY(-3px);
  box-shadow: 0 12px 20px rgba(52, 152, 219, 0.4);
}

.custom-btn.secondary {
  background: #2ecc71;
  color: white;
  box-shadow: 0 8px 15px rgba(46, 204, 113, 0.3);
}

.custom-btn.secondary:hover {
  background: #27ae60;
  transform: translateY(-3px);
  box-shadow: 0 12px 20px rgba(46, 204, 113, 0.4);
}

.custom-btn.outline {
  background: transparent;
  color: #34495e;
  border: 3px solid #34495e;
  box-shadow: 0 8px 15px rgba(52, 73, 94, 0.2);
}

.custom-btn.outline:hover {
  background: #34495e;
  color: white;
  transform: translateY(-3px);
  box-shadow: 0 12px 20px rgba(52, 73, 94, 0.3);
}

@media (max-width: 768px) {
  .button-container {
    flex-direction: column;
    gap: 2rem;
  }

  .custom-btn {
    padding: 15px 40px;
    font-size: 20px;
    width: 80%;
    max-width: 300px;
  }
}
</style>
